import React, { useState, useCallback } from "react";
import "./App.css";



// Import pages
import Header from "./modules/Header";
import Headermobile from "./modules/Headermobile";
import { Rates } from "rate-quotes";
import Container from "react-bootstrap/Container";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import Footer from "./modules/Footer";
import Testimonials from "./modules/Testimonials";
import MediaQuery from "react-responsive";
import { CookieSetting } from "cookiesetting-component";


function App() {
  // stores current formRef
  const [node, setNode] = useState(null);
  // tracks changes to formRef and stores current with setNode
  const contactRef = useCallback((node) => {
    setNode(node);
  }, []);

  return (
    <>
    <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    
    <div className="App">
      <MediaQuery minWidth={768}>
          <Header />
          </MediaQuery>
          <MediaQuery maxWidth={767}>
          <Headermobile />
        </MediaQuery>
      <Rates
        leadSource="NET049"
        phoneText="1-(844)786-9378"
        phoneNumber="tel:+18447869378"
        offertext="$750 Lender Credit"
      />
      <div className="formWrapper">
        {node && (
          // dynamically renders the custom form header
          <div className="formHeader">Contact Us</div>
        )}
        <Container className="formBody">
          <BorrowerLeadGenerationTool
            phoneNumber="tel:+18447869378"
            leadSource="NET049"
            phoneText="(844)786-9378"
            supportEmailId="lead.management@swmc.com"
            ref={contactRef}
          />
        </Container>
      </div>
      <Testimonials />
      <Footer />
    </div>
    </>
  );
}

export default App;
